import type { ReactNode } from 'react';

export interface Stat {
  label: string;
  value: ReactNode;
  /** `up`, `down` and `pending` tone the number and its dot; absent is neutral. */
  tone?: 'up' | 'down' | 'pending';
}

/**
 * A section's numbers as one quiet summary row.
 *
 * Small enough to sit above a list without pushing it off the screen, and a
 * definition list because that is what it is, so a screen reader reads
 * "Published: 4" rather than two unrelated fragments. A tone marks the number
 * worth acting on: an unanswered message, a live advert.
 */
export function StatStrip({ stats, testId }: { stats: readonly Stat[]; testId?: string }): React.JSX.Element | null {
  if (stats.length === 0) return null;

  return (
    <dl className="stats" data-testid={testId}>
      {stats.map((stat) => (
        <div className={`stat${stat.tone ? ` stat--${stat.tone}` : ''}`} key={stat.label}>
          <dt className="stat__label">{stat.label}</dt>
          <dd
            className="stat__value"
            data-testid={testId ? `${testId}-${stat.label.replace(/\s+/g, '-').toLowerCase()}` : undefined}
          >
            {stat.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
